import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const AttachIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 18 18" {...props}>
            <path
                d="M8 .91C6.29.91 4.91 2.29 4.91 4v11c0 2.26 1.83 4.09 4.09 4.09s4.09-1.83 4.09-4.09V5L13 4.91h-1l-.09.09v10c0 1.61-1.3 2.91-2.91 2.91S6.09 16.61 6.09 15V4c0-1.05.86-1.91 1.91-1.91 1.05 0 1.91.86 1.91 1.91v9c0 .5-.41.91-.91.91s-.91-.41-.91-.91V5L8 4.91H7L6.91 5v8c0 1.15.94 2.09 2.09 2.09s2.09-.94 2.09-2.09V4C11.09 2.29 9.71.91 8 .91z"
                transform="translate(-1124 -564) translate(1090) translate(32 560) translate(2 3)"
            />
        </SvgIcon>
    );
};
